import { Options } from '../Options'

export const analyticsCardOptions = Options.asRecord()

export type AnalyticsCardOptions = Options.TypeOf<typeof analyticsCardOptions>
